export default {
  taskAssignment: {
    title: 'Task Assignment',
    subtitle: 'Manage and assign installation tasks to installers',
    installers: 'Installer Users',
    unassignedInstallations: 'Unassigned Installations',
    searchInstallers: 'Search installers...',
    searchInstallations: 'Search installations...',
    tasksCount: 'Tasks: {count}',
    dragHint: 'Drag installation to assign',
    taskDetails: 'Task Details',
    tasks: 'Tasks & Workload',
    taskAssigned: 'Task has been successfully assigned',
    taskUnassigned: 'Task has been successfully unassigned',
    assignFailed: 'Failed to assign task. Please try again.',
    unassignFailed: 'Failed to unassign task. Please try again.',
    noInstallersFound: 'No installers found',
    noInstallationsFound: 'No installations found'
  },
  installerTasks: {
    filterStatus: 'Status',
    status: {
      assigned: 'Assigned',
      inProgress: 'In progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
  },
}
